export default __webpack_public_path__ + "static/media/mexc.d211f602.svg";